import { VF_CORRECTIVE_DATE_PICKER } from 'AppSrc/core/components/forms/form-base-components/v-f-corrective-date-picker';
import {
  INLINE_ERRORS,
  // SILENT_ERRORS,
  commonValidation,
  cleanUpFieldErrors,
  getDefaultFieldErrors,
} from 'AppSrc/core/components/forms/form-base-components/utility/common-validation';
import { CORRECTIVE_ACTION_COMPLETION_DATE } from 'AppSrc/core/components/forms/form-types/completion-review/form-definition/section-constants';
import { correctiveActionCompletion } from './corrective_action_completion';

const fieldId = CORRECTIVE_ACTION_COMPLETION_DATE;

const validator = (params) => {
  const {
    values,
    field,
    // formData,
  } = params;
  const {
    optional,
  } = field;

  const value = values[fieldId];


  // const { minDate, maxDate } = field.componentData.vFParams;
  // const dateIsBeforeMin = commonValidation.date.isBeforeMinDate(value, minDate);
  // const dateIsAfterMax = commonValidation.date.isAfterMaxDate(value, maxDate);


  /* MAKE A DEFAULT ERRORS OBJECT */
  const errors = getDefaultFieldErrors();
  const shouldValidate = values[correctiveActionCompletion.id] ? values[correctiveActionCompletion.id].includes('No') : false;
  if (shouldValidate) {
  /* ERROR CHECKERS */
    const noValue = commonValidation.noValue(value, VF_CORRECTIVE_DATE_PICKER);

    /* ADD ERRORS TO ERROR OBJECT */
    errors[INLINE_ERRORS].push((noValue && !optional) ? 'Please enter expected completion date.' : null);
  // errors[INLINE_ERRORS].push((noValue && !optional) ? <FieldWarningError /> : null);
  // errors[INLINE_ERRORS].push(dateIsBeforeMin ? 'The start date can not be before the CRQ scheduled start date' : null);
  // errors[INLINE_ERRORS].push(dateIsAfterMax ? 'The start date can not be after the CRQ scheduled end date' : null);
  }

  /* REMOVE BLANK ERRORS (because Formik gets confused) */
  return cleanUpFieldErrors(errors);
};

// This overwritten by the form :)
const initialValues = null;

const vFParams = {
  fieldTitle: 'If selected ‘No’ above, then add the expected completion date',
  displayType: 'small',
};

const expectedCompletionDate = {
  id: fieldId,
  validator,
  vFParams,
  initialValues,
  fieldType: VF_CORRECTIVE_DATE_PICKER,
};

export { expectedCompletionDate };
